<div class="jk-rich-editor">
  @if(label) {
  <div style="margin-bottom:4px;">
    <label style="font-size:12px; color:#555;">{{ label }}
      @if(required()) {
      <span style="color:red;">*</span>
      }
    </label>
  </div>
  }
  @if(readonly()) {
  <quill-editor [ngModel]="editorValue" [readOnly]="true"
    [modules]="{toolbar: false}" theme="bubble"
    style="display:block; min-height:150px; border:1px solid #ccc; border-radius:4px;">
  </quill-editor>
  } @else {
  <input #imageInput type="file" accept="image/*" style="display:none"
    (change)="onImageFileSelected($event)">
  <quill-editor theme="snow" [ngModel]="editorValue" (ngModelChange)="onModelChange($event)"
    [modules]="quillModules"
    [style.min-height]="minHeight()"
    style="display:flex; flex-direction:column; width:100%;"
    (onEditorCreated)="onQuillEditorCreated($event)">
  </quill-editor>
  <div style="margin-top:4px;">
    <button type="button"
      style="font-size:12px; height:28px; line-height:28px;"
      (click)="toggleMinioImages()" class="btn-primary">
      {{ showMinioImages ? '收起已上傳圖片' : '選擇已上傳圖片' }}
    </button>
    <button type="button"
      style="font-size:12px; height:28px; line-height:28px; margin-left:4px;"
      (click)="toggleRawText()" class="btn-primary">
      {{ showRawText ? '收起原始文字' : '查看原始文字' }}
    </button>
    <button type="button"
      style="font-size:12px; height:28px; line-height:28px; margin-left:4px;"
      (click)="pastePlainText()" [disabled]="readonly()" class="btn-primary">
      貼上文字
    </button>
    <button type="button"
      style="font-size:12px; height:28px; line-height:28px; margin-left:4px;"
      (click)="pasteHtml()" [disabled]="readonly()" class="btn-primary">
      貼上 HTML
    </button>
  </div>
  @if(showRawText) {
  <textarea readonly [value]="editorValue"
    aria-label="原始 HTML 文字"
    style="display:block; width:100%; min-height:150px; margin-top:4px; padding:8px; box-sizing:border-box; font-family:monospace; font-size:12px; border:1px solid #ccc; border-radius:4px; background:#f8f8f8;"></textarea>
  }
  @if(showMinioImages) {
  <div style="border:1px solid #ddd; border-radius:4px; padding:8px; margin-top:4px; min-height:60px;">
    @if(minioImagesLoading) {
    <span style="color:#888; font-size:13px;">載入中...</span>
    } @else if(minioImages.length === 0) {
    <span style="color:#aaa; font-size:13px;">此單號尚無已上傳圖片</span>
    } @else {
    @for(img of minioImages; track img.url) {
    <img [src]="img.url" [title]="img.name"
      (click)="insertMinioImage(img.url)"
      style="width:100px; height:80px; object-fit:cover; cursor:pointer; margin:4px; border:1px solid #ccc; border-radius:4px;">
    }
    }
  </div>
  }
  }
</div>
